import cn from 'classnames';
import { Wrapper } from 'components/base';
import LinkHref from 'components/LinkHref';
import PropTypes from 'prop-types';
import React from 'react';
import { activeLink, desc, heading, image, lists, mainData, navItem, notificationIsShown as nShown, root, sideData, textItem, title, wrapper } from './HeaderDropdown.module.scss';

const HeaderDropdown = ({ notificationIsShown, productData  }) => {
  return (
    <>
      <div
        className={cn(root, {
          [nShown]: notificationIsShown,
        })}
      >
        <Wrapper size="L" className={wrapper}>
          <div className={mainData}>
            <div className={title}>{productData.data.title}</div>
            <ul className={lists}>
              { productData.data.list.map((item, i) => (
                <li key={i} className={navItem}>
                  <div className={image}>
                    <img src={item.image.publicURL} alt={item.heading} />
                  </div>
                  <div className={textItem}>
                    <LinkHref link={item.link} text={item.heading} className={heading} activeClassName={activeLink} openNew={item.openNew} />
                    <LinkHref link={item.link} text={item.desc} className={desc} openNew={item.openNew} />
                  </div>
                  
                </li>
              )) }
            </ul>
          </div>
          <div className={sideData}>
            <div className={title}>{productData.dataSide.title}</div>
            <ul>
              { productData.dataSide.list.map((item, i) => (
                <li key={i} className={navItem}>
                  <div className={image}>
                    <img src={item.image.publicURL} alt={item.heading} />
                  </div>
                  <div className={textItem}>
                    <LinkHref link={item.link} text={item.heading} className={heading} activeClassName={activeLink} openNew={item.openNew} />
                    <LinkHref link={item.link} text={item.desc} className={desc} openNew={item.openNew} />
                  </div>
                </li>
              )) }
            </ul>
          </div>
        </Wrapper>
      </div>
    </>
  )
};
HeaderDropdown.propTypes = {
  notificationIsShown: PropTypes.bool.isRequired,
  productData: PropTypes.object.isRequired,
};
HeaderDropdown.defaultProps = {
  isOpen: false,
  notificationIsShown: false,
};

export default HeaderDropdown;
